@import (reference) '../../../constants/spacing.module.less';

.fulfillment-display-section {
  display: flex;
  flex-flow: column nowrap;
  align-items: stretch;
  justify-content: center;
  gap: @space-8;

  padding: @space-0 @space-16 @space-24;
}
